export default "__VITE_ASSET__3f6dfda7__"